import { useUser } from "@/app/context/UserContext";
import React, { ChangeEvent, use, useEffect, useRef, useState } from "react";
import DropdownUser from "../DropdownUser/DropdownUser";
import { ChevronLeft, CircleUserRound, LogIn, Pencil, Projector, Settings, Upload, UserRound } from "lucide-react";
import GoogleLogin from "../Login/Login";
import { onAuthStateChanged } from "firebase/auth";
import { auth, signInAnonymous } from "@/app/helpers/firebase";

import { AccessType, AlertType, DomainUser, ModeLayout, TypeEnvironment } from "@/app/constants/enums";
import Loading from "../Elements/Loading";
import { Constantes } from "@/app/constants/constantsGlobal";
import Avatar from "../Elements/Avatar";
import { iUserLoginInfo, iUserLoginRequest } from "@/app/models/interfaceUserLogin";
import { iResponse } from "@/app/models/interfaceResponse";
import { userLoginDetailService } from "@/app/services/userLoginDetailService";
import { iGenericAccessDetail, iProProjectMain } from "@/app/models/interfaceProject";
import { useConfig } from "@/app/context/ConfigContext";
import ShareMenu from "../Elements/ShareMenu";
import DynamicFormField from "../Permissions/LoginDisabled/DynamicFormField";
import Modal from "../Elements/Modal";
 type LayoutHeaderProps = {
  show?: boolean; // Si es false, no se renderiza
};
const DEFAULT_CONFIG: iGenericAccessDetail = {
    label: "",
    placeholder: "",
    validation: [],
}; 

const LayoutHeader = ({ show = true }: LayoutHeaderProps) => {
  const { queryParams, baseUrl } = useConfig();
  const { user, setUser, 
          accessType,setAccessType,
          setUserLoaded, setUserLoginInfo,
          userProject,setUserProject, 
          userProjectLoading, 
          modeLayout, addAlert,
          userProjectLoaded, setUserProjectLoaded,
          } = useUser();// Accedemos al usuario logueado desde el contexto
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isOpenDropdownUser, setOpenDropdownUser] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const openCloseDropdownUser = () => setOpenDropdownUser(!isOpenDropdownUser);
  const openDropdownUser = () => setOpenDropdownUser(true);
  const closeDropdownUser = () => setOpenDropdownUser(false);
  const openLoginModal = () => setIsLoginOpen(true);
  
  const [imageError, setImageError] = useState(false);
  //
  const userLoginDetail = async (vUser:any) => {
    try {
      const request: iUserLoginRequest = {
        login: {
          tokenId: vUser?.accessToken || "",
          email: vUser?.email || "",
          localId:vUser?.uid
        },
      };  
      const response: iResponse = await userLoginDetailService(request, user, setUser); 
      if (response.success && response.data) {
        const dataResponse: iUserLoginInfo = response.data as iUserLoginInfo
        setUserLoginInfo(dataResponse); 
        setUserProject((prev: iProProjectMain) => ({
            ...prev,
            project: {
              ...prev.project,
              domain: dataResponse.domain,
            },
          }));
      }  
    } catch (err) {
      console.error("Error obteniendo dominio:", err); 
    }
  };
  useEffect(() => { 
    // ?? if user
    if(user?.accessToken && userProject?.project?.domain==='') {
      userLoginDetail(user)
    } 
  }, [user?.accessToken, userProject?.project?.domain]);
  // login generico
  const [loadingGeneric, setLoadingGeneric] = useState(false);
  const [isShowGenericIdent, setIsShowGenericIdent] = useState(false);
  
  const handleGenericLogin = async (value: string) => {
    setLoadingGeneric(true)
    try { 
      setUser((prev: any) => ({
        ...prev,
        displayName: value,
        //email: `AUSR::${value}`,
        genericUser: `AUSR::${value}`,
      })); 
      setIsShowGenericIdent(false);
    } finally { 
      setLoadingGeneric(false)
    }
  };

  // Usuario
  useEffect(() => { 
    let unsubscribe: (() => void) | null = null; 

    const initAuth = async () => { 
      unsubscribe = onAuthStateChanged(auth, async (currentUser) => { 
        if (currentUser) {
          setUser(currentUser);
          setAccessType(AccessType.LogIn); 
        } else {
            if(queryParams.incognito){
              setAccessType(AccessType.Incognito);
              const anonUser = await signInAnonymous(); 
              setUser(anonUser);
              if(userProject?.project?.generic_access){
                //console.log(userProject?.project?.generic_access)
              } 
            }else{ 
              if(user?.isAnonymous){
                setAccessType(AccessType.Incognito);
                if(userProject?.project?.generic_access){
                  // 
                } else{
                  const anonUser = await signInAnonymous(); 
                  setUser(anonUser);
                }
              }else{
                setIsLoginOpen(true);
              } 
            }
        }
        setUserLoaded(true);
      });
    }; 
    
    initAuth(); 
    return () => {
      if (unsubscribe) unsubscribe();
    };

  }, [user?.email]);
 
  // EDITAR//
  const [isEditingForm, setIsEditingForm] = useState(true);
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingAlias, setIsEditingAlias] = useState(false);
  const [isEditingDesc, setIsEditingDesc] = useState(false);
  const [isImageMAxSize, setIsImageMAxSize] = useState(false);

  useEffect(() => {
    if(userProjectLoaded&&userProject&&userProject.project.env == TypeEnvironment.Prod){ 
      setIsEditingForm(false);
    }  
  }, [ userProjectLoaded]);

  useEffect(() => {
    if(userProjectLoaded&&userProject&&userProject.project.generic_access && !user?.genericUser?.startsWith('AUSR::')&&accessType==AccessType.Incognito
    ){  
      setIsShowGenericIdent(true);
    }
  }, [userProject?.project?.generic_access]);
  

     
  const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setIsImageMAxSize(file.size > Constantes.MAX_IMAGE_SIZE);
    if (file.size > Constantes.MAX_IMAGE_SIZE) { 
      return;
    }

    
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (typeof reader.result === "string") {
          setUserProject((prev: any) => ({
            ...prev,
            project: {
                ...prev.project,
                icono: reader.result, // Guarda la imagen en el contexto
            }
          }));
          // userProject.project.image = reader.result;
          //setImage(reader.result); // Guarda la imagen en Base64
      }
      reader.onerror = () => {
          console.error("Error al leer el archivo");
      }; 
    }; 
  };

  const inputRef = useRef<HTMLInputElement | null>(null);
  const handleButtonClick = () => {
      if (inputRef.current) {
        inputRef.current.click();
      }
    };

  const [errorAlias, setErrorAlias] = useState(false);

  const handleAliasChange = (value: string) => {
    setUserProject((prev: any) => ({
      ...prev,
      project: { ...prev.project, alias: value.trim() },
    }));
  };

  const handleAliasBlur = () => {
    const alias = userProject?.project?.alias?.trim() || ""; 
    if (!alias) {
      //addAlert("El alias no puede estar vacío.", AlertType.Warning);
      //setErrorAlias(true)
      setErrorAlias(false)
      setIsEditingAlias(false)
      return;
    }
    // Validar formato tipo URL-friendly
    const urlPattern = /^[a-zA-Z0-9-_]+$/;
    if (!urlPattern.test(alias)) {
      addAlert("Solo se permiten letras, números, guiones y guiones bajos.", AlertType.Warning);
      setErrorAlias(true)
      return;
    } 
    setErrorAlias(false)
    setIsEditingAlias(false)
  };
    

 

  
  return (
    <header className={`flex items-center justify-between 
      transition-all duration-100
        ${show ? 'animate-slideDown p-4 ' : 'animate-slideUp h-0 p-0 m-0'}
      `}>
    <div className={`flex items-center space-x-4 ${show ? '' : 'h-0'} `} >  
    
        { userProjectLoading ? 
            <div className={`flex ${show ? '' : 'hidden'} `}>
              <Loading w="w-3" h="h-3" className="" />
              <p className="text-base text-gray-500 mt-2">
                loading...
              </p> 
            </div>
          : 
            !userProject ? (!userProjectLoading && show? <span className=''> Incorrect configuration </span>: '') : 
              
              <div className={`flex ${show ? '' : 'h-0'} `}> 
                <div className={`${show ? 'w-12 h-12' : 'w-0 h-0'} relative mx-auto mr-2`}>
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden" 
                    onChange={handleImageChange}
                    ref={inputRef}
                  />
                  
                  
                  <div
                    className="w-full h-full rounded-lg bg-cover bg-center flex items-center justify-center "
                    style={{
                      backgroundImage: userProject?.project?.icono?.length
                        ? `url(${userProject?.project?.icono})`
                        : "url('/images/icon_pruebas.7945925c.png')",
                      backgroundSize: "cover",
                    }}
                  > 
                    {(modeLayout==ModeLayout.Edit && isEditingForm)?
                      <>
                        <button 
                          className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:opacity-100 transition-colors border border-gray-300 opacity-0"
                          onClick={handleButtonClick}
                          aria-label="Editar"
                        >
                        <Upload className="w-5 h-5 text-gray-700" strokeWidth={1.5} /> 
                        </button> 
                        <button 
                          className="flex items-center justify-center relative"
                          onClick={handleButtonClick}
                          aria-label="Editar"
                        >
                          <Pencil 
                            className="absolute -bottom-5 -right-3 w-5 h-5 ml-5 cursor-pointer text-white mix-blend-difference" 
                            strokeWidth={1} 
                          />
                        </button> 
                      </>
                    : ''}
                    
                  </div>
                  
                </div>
                <div className="flex items-center gap-6">
                <div className="flex"> 
                  <h1 
                    className="text-lg font-semibold text-gray-900 flex items-center gap-2"
                  > 
                    {userProject?userProject?.project?.project_name:''}    
                  </h1> 
                </div>
                </div>
                {/*
                <div>

                  <div className="flex items-center gap-6">
                       {isEditingForm && isEditingName && modeLayout==ModeLayout.Edit ? (
                        <div className="flex items-center gap-2">
                          <label className="font-medium">Proyecto:</label>                        
                          <input 
                            type="text"
                            value={userProject?userProject?.project?.project_name:''}
                            autoFocus
                            onBlur={() => setIsEditingName(false)}
                            onChange={(e) => setUserProject((prev: any) => ({
                                ...prev,
                                project: { ...prev.project, project_name: e.target.value },
                              })) 
                            }
                            className="w-full border-b-2 border-gray-300 outline-none focus:border-blue-500 bg-body"
                          />
                        </div>
                        
                        
                      ) : (
                        <div className="flex"> 
                          <h1 
                            className="text-lg font-semibold text-gray-900 flex items-center gap-2"
                            onClick={() => setIsEditingName(true)}
                          > 
                            {userProject?userProject?.project?.project_name:''}
                            
                          </h1> 
                          {isEditingForm && modeLayout==ModeLayout.Edit&&(<Pencil onClick={() => setIsEditingName(true)} className="w-5 h-5 text-gray-700 ml-5 cursor-pointer" strokeWidth={1} />)}
                        </div> 
                      )}

                      {isEditingAlias && modeLayout==ModeLayout.Edit ? (
                        <div className="flex items-center gap-2 relative">
                          <label className="font-medium">Alias:</label>

                          <input
                            type="text"
                            value={userProject ? userProject?.project?.alias : ""}
                            autoFocus
                            onBlur={handleAliasBlur}
                            onChange={(e) => handleAliasChange(e.target.value)}
                            className={`flex-1 border-b-2 outline-none bg-body transition-colors ${
                              errorAlias
                                ? "border-red-500 focus:border-red-500"
                                : "border-gray-300 focus:border-blue-500"
                            }`}
                            placeholder="ej: mi-asistente"
                          />

                          <div className="relative group cursor-pointer">
                            <Info size={18} className="text-gray-500" />

                            <span
                              className="
                                absolute left-1/2 -translate-x-1/2 mt-2 
                                w-max max-w-xs 
                                bg-black text-white text-xs px-2 py-1 
                                rounded shadow-lg opacity-0 group-hover:opacity-100 
                                transition-opacity z-10
                              "
                            >
                              {userProject?.project?.env === TypeEnvironment.Prod
                                ? "Debe ser distinto a la versión sandbox"
                                : "Debe ser distinto a la versión final"}
                            </span>
                          </div>
                        </div>
                        
                      ) : (
                         <div className="flex"> 
                            {userProject?.project?.alias && (
                              <p
                                className="text-sm text-gray-500 flex items-center gap-1"
                                onClick={() => setIsEditingAlias(true)}
                              >
                                ({userProject.project.alias})
                              </p>
                            )}
                          {modeLayout==ModeLayout.Edit&&(
                            <>
                              {userProject?.project?.alias ? '' : "Alias:"}
                              <Pencil onClick={() => setIsEditingAlias(true)} className="w-5 h-5 text-gray-700 ml-5 cursor-pointer" strokeWidth={1} />
                            </>
                          )}
                            
                        </div> 
                      )}
                  </div>
                 




                  {isEditingForm && isEditingDesc && modeLayout==ModeLayout.Edit? (
                        <input
                          type="text"
                          value={userProject?.project?.description}
                          autoFocus
                          onBlur={() => setIsEditingDesc(false)}
                          onChange={(e) => setUserProject((prev: any) => ({
                              ...prev,
                              project: { ...prev.project, description: e.target.value },
                            }))                             
                          }
                          className="w-full border-b-2 border-gray-300 outline-none focus:border-blue-500  bg-body"
                        />
                      ) : (
                        <div className="flex">
                          <p 
                            className="text-sm text-gray-600 italic"
                            onClick={() => setIsEditingDesc(true)}
                          > 
                            {userProject?.project?.description} 
                          </p>
                          {isEditingForm && modeLayout==ModeLayout.Edit&&(<Pencil onClick={() => setIsEditingDesc(true)} className="w-5 h-5 text-gray-700 ml-5 cursor-pointer" strokeWidth={1} />)} 

                            {isImageMAxSize?<p className='absolute left-0 top-14 z-20 text-red-500'> Tamaño máximo permitido: 2MB</p>:''} 
                        </div>
                         
                  )}
                  
                </div>*/}
              </div> 
        }
       
    </div> 
     
    <GoogleLogin isModalOpen={isLoginOpen} closeModal={() => setIsLoginOpen(false)} />

    {show && accessType==AccessType.LogIn&&
    <div className="flex space-x-4" ref={dropdownRef}> 
      {user ? (
        <div className="flex items-center"> 
          

  {/* <ShareMenu  />*/}
  

          <button 
              className=" flex items-center gap-2 hover:opacity-50 transition-colors rounded-full w-10"
              onClick={openCloseDropdownUser} 
              aria-label="Changechange user"
            > 
            {  user?.photoURL && !imageError ? (
              <img
                src={user.photoURL}
                alt="Avatar"
                className="w-10 h-10 rounded-full"
                onError={() => setImageError(true)} // Si la imagen falla, cambia a la inicial
              />
            ) : ( 
                  <Avatar className="rounded-full w-10 h-10" user={user} />
            )}  
            </button> 
            <DropdownUser isOpen={isOpenDropdownUser} onOpen={openDropdownUser} onClose={closeDropdownUser} dropdownRef={dropdownRef}/>
          </div>
      ) : (
        <button 
          type="button"
          className="hover:opacity-50 transition-colors rounded-full bg-current p-2"
          onClick={openLoginModal} 
          aria-label="Changechange user"
        > 
          <LogIn className='text-white' strokeWidth={1}  /> 
        </button>
      )} 
    </div> 
    }

    {user?.genericUser && (
      <div
        className="flex items-center gap-2 rounded-full bg-gray-100 dark:bg-gray-800 px-3 py-1 
                  hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors cursor-pointer"
        aria-label="Cambiar usuario"
        title="Cambiar usuario"
      >
        {/* Avatar */}
        <Avatar className="rounded-full w-8 h-8" user={user} />
        {/* Nombre */}
        <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
          {user.displayName}
        </span>
      </div>
    )}

    
      


      <Modal
            isOpen={isShowGenericIdent}
            onClose={() => setIsShowGenericIdent(false)}
            btnClose={false}
          >
        <div className="bg-white rounded-lg shadow-lg text-center n-card-loggin relative animate-fadeIn">
          {userProjectLoaded && userProject && userProject.project.generic_access ? (
                <>
                {accessType!=AccessType.Incognito&&(
                  <div className="relative "> 
                    <button
                      onClick={() =>{
                        setIsLoginOpen(true);
                        setIsShowGenericIdent(false);
                      } }
                      className="absolute n-buttons shadow-md -top-5 -left-3 flex items-center justify-center w-10 h-10 rounded-full transition-all"
                    >
                      <ChevronLeft className="w-5 h-5" strokeWidth={1.5} />
                    </button> 
                  </div> 
                  )}
                  <div className="icono-loggin flex justify-center items-center">
                    <CircleUserRound strokeWidth={0.3} size={200} />
                  </div>
                  <DynamicFormField
                    config={userProject.project.generic_access_detail ?? DEFAULT_CONFIG}
                    loading={loadingGeneric}
                    onSubmit={(value) => {
                      handleGenericLogin(value);
                    }}
                  />
                </>
              ):
              <div className="flex justify-center items-center min-h-[120px]">
                <p>El acceso genérico no está <br/>configurado para este proyecto.</p>
              </div>
          }
        </div>
      </Modal>
   



  </header>
  );
};

export default LayoutHeader;